import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global/global.service';
@Component({
  selector: 'app-modal-icon',
  templateUrl: './modal-icon.component.html',
  styleUrls: ['./modal-icon.component.scss'],
})
export class ModalIconComponent implements OnInit {
  icon: string;
  color: boolean = false;
  constructor(
    public globalService: GlobalService,
    public dialogRef: MatDialogRef<ModalIconComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      icon: string
      title: string
      content: string
      bold: string
      cancelbtn: string
      confirmbtn: string
      bullet: any
      msgSucces: string
    }
  ) {

      if(data.title == "Los cambios fueron guardados con éxito"){
        this.color = true;
      }
  }

  ngOnInit() {
    this.icon= this.data.icon?this.data.icon: ''
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel(){
    this.dialogRef.close(false);
  }
}
